<template>
  <div class="container">
    <Header></Header>
    <div class="content wrap">
      <div class="tTop">
        <div class="tTLeft">
          <swiper :options="swiperOption" :key="0">
            <swiper-slide v-for="(slide, index) in swiperSlides" :key="index">
              <div class="slideItem" @click="openLink(slide.id)">
                <img :src="slide.shufflPic" alt="" />
                <div class="slideNewsTitle">{{ slide.title }}</div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="tTRight">
          <NewsTabs :tabsData="tabsData0" :key="0" :isTop="true"></NewsTabs>
        </div>
      </div>

      <div @click="tClick('as')" class="tPic tmt">
        <img src="@img/quotation.jpg" alt="" />
      </div>

      <div class="tMiddle">
        <div class="tLeft">
          <NewsTabs :tabsData="tabsData1" :key="1"></NewsTabs>
          <NewsTabs :tabsData="tabsData2" :key="2"></NewsTabs>
          <NewsTabs :tabsData="tabsData3" :key="3"></NewsTabs>
        </div>
        <div class="tRight">
          <div class="qrCode">
            <div class="qrTitle">广东省政府采购协会<br />微信公众号：gdszfcgxh</div>
            <div class="qrPic">
              <img src="@img/qrCode.png" alt="" />
            </div>
          </div>
          <div class="consult">
            <div class="btn" @click="toEmail(0)">
              <i></i>
              <span>会员业务咨询</span>
            </div>
            <div class="btn" @click="toEmail(1)">
              <i></i>
              <span>会长邮箱</span>
            </div>
            <div class="btn" @click="toEmail(2)">
              <i></i>
              <span>秘书长邮箱</span>
            </div>
            <div class="btn trainBtn" @click="toTrain()">
              <i></i>
              <span>教育培训</span>
            </div>
          </div>
          <div class="directory">
            <div class="d-title">会员名录</div>
            <div class="d-list">
              <!-- <ul ref="dList" :class="{ anim: animate == true }">
                <li v-for="(item, key) in member" :key="key">{{ item.unitName }}</li>
              </ul> -->
              <vue-seamless-scroll :data="member" :class-option="classOption" class="cWarp">
                <ul class="item">
                  <li v-for="(item, index) in member" :key="index">
                    {{ item.unitName }}
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>

      <div class="activity">
        <div class="d-title"><span>协会活动图片集</span></div>
        <div class="swiper-box">
          <swiper :options="swiperActivityOption" :key="0">
            <swiper-slide v-for="(slide, index) in tabsData4[0].records" :key="index">
              <img :src="slide.activityPic" alt="" />
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
          </swiper>
        </div>
      </div>
      <FriendshipLinks> </FriendshipLinks>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import FriendshipLinks from '@/components/FriendshipLinks.vue';
import NewsTabs from '@/components/NewsTabs.vue';

import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import vueSeamlessScroll from 'vue-seamless-scroll';
import moment from 'moment';
export default {
  name: 'home',
  data() {
    return {
      colData: [
        {
          id: 1,
          colValue: '协会动态'
        },
        {
          id: 2,
          colValue: '通知公告'
        },
        {
          id: 3,
          colValue: '政策法规'
        },
        {
          id: 4,
          colValue: '会员服务',
          children: [
            {
              id: 43,
              colValue: '会员风采'
            },
            {
              id: 41,
              colValue: '会员服务简介'
            },
            {
              id: 42,
              colValue: '业务指南'
            },
            {
              id: 44,
              colValue: '有问有答'
            },
            {
              id: 45,
              colValue: '专业书刊'
            },
            {
              id: 46,
              colValue: '业务探讨'
            }
          ]
        },
        {
          id: 5,
          colValue: '教育培训',
          children: [
            {
              id: 51,
              colValue: '培训信息'
            },
            {
              id: 52,
              colValue: '微课堂'
            }
          ]
        },
        {
          id: 6,
          colValue: '诚信自律'
        },
        {
          id: 7,
          colValue: '关于协会'
        },
        {
          id: 8,
          colValue: '行业资讯'
        },
        {
          id: 9,
          colValue: '活动图集'
        }
      ],
      tabsData: [],
      tabsData0: [
        {
          id: 2,
          colValue: '通知公告',
          records: []
        },
        {
          id: 1,
          colValue: '协会动态',
          records: []
        }
      ],
      tabsData1: [
        {
          id: 3,
          colValue: '政策法规',
          records: []
        },
        {
          id: 8,
          colValue: '行业资讯',
          records: []
        } /* ,
        {
          id: 6,
          colValue: '诚信自律',
          records: []
        } */
      ],
      tabsData2: [
        [
          {
            id: 5,
            colValue: '教育培训',
            children: [
              {
                id: 51,
                colValue: '培训信息',
                records: []
              },
              {
                id: 52,
                colValue: '微课堂',
                records: []
              }
            ]
          }
        ]
      ],
      tabsData3: [
        [
          {
            id: 4,
            colValue: '会员服务',
            children: [
              {
                id: 43,
                colValue: '会员风采',
                records: []
              },
              {
                id: 41,
                colValue: '会员服务简介',
                records: []
              },
              {
                id: 42,
                colValue: '业务指南',
                records: []
              },
              {
                id: 44,
                colValue: '有问有答',
                records: []
              },
              {
                id: 45,
                colValue: '专业书刊',
                records: []
              },
              {
                id: 46,
                colValue: '业务探讨',
                records: []
              }
            ]
          }
        ]
      ],
      tabsData4: [
        {
          id: 9,
          colValue: '活动图集',
          records: []
        }
      ],

      animate: false,
      items: [
        '珠海华信达工程顾问有限公司1',
        '珠海华信达工程顾问有限公司2',
        '珠海华信达工程顾问有限公司3',
        '珠海华信达工程顾问有限公司4',
        '珠海华信达工程顾问有限公司5',
        '珠海华信达工程顾问有限公司6',
        '珠海华信达工程顾问有限公司7',
        '珠海华信达工程顾问有限公司8',
        '珠海华信达工程顾问有限公司9',
        '珠海华信达工程顾问有限公司00'
      ],
      //轮播图配置
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      //轮播图配置
      swiperActivityOption: {
        /* slidesPerView: 4,
        loop: true,
        spaceBetween: 10,
        loopedSlides: 5,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        }, // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        } */
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        initialSlide: 2,
        autoplay: {
          delay: 1500,
          disableOnInteraction: false
        },
        coverflowEffect: {
          rotate: 45,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      swiperSlides: [],
      member: [],
      //活动图集配置
      classOption: {
        direction: 1
      }
    };
  },
  created() {
    //this.getFrontCol();
  },
  mounted() {
    //从本地获取数据
    if (sessionStorage.getItem('tabsData0')) {
      this.tabsData0 = JSON.parse(sessionStorage.getItem('tabsData0'));
    }
    if (sessionStorage.getItem('tabsData1')) {
      this.tabsData1 = JSON.parse(sessionStorage.getItem('tabsData1'));
    }
    if (sessionStorage.getItem('tabsData2')) {
      this.tabsData2 = JSON.parse(sessionStorage.getItem('tabsData2'));
    }
    if (sessionStorage.getItem('tabsData3')) {
      this.tabsData3 = JSON.parse(sessionStorage.getItem('tabsData3'));
    }
    if (sessionStorage.getItem('tabsData4')) {
      this.tabsData4 = JSON.parse(sessionStorage.getItem('tabsData4'));
    }
    if (sessionStorage.getItem('swiperSlides')) {
      this.swiperSlides = JSON.parse(sessionStorage.getItem('swiperSlides'));
    }
    if (sessionStorage.getItem('member')) {
      this.member = JSON.parse(sessionStorage.getItem('member'));
    }

    //更新数据
    //顶部轮播图
    this.getSlideList();

    this.getMember();

    this.tabsData = JSON.parse(JSON.stringify(this.colData));
    this.tabsData.forEach((item, fIndex) => {
      if (item.id === 4 || item.id === 5) {
        item.children.forEach((sItem, sIndex) => {
          this.getList(item.id, fIndex, sItem.id, sIndex);
        });
      } else {
        this.getList(item.id, fIndex);
      }
    });
  },
  methods: {
    getList(id, fIndex, sId, sIndex) {
      this.$api(
        this.$config.apiUrl.frontList,
        {
          type: sId ? sId : null,
          parentType: sId ? null : id,
          current: 1,
          size: id === 1 || id === 2 ? 8 : 10
        },
        { method: 'get' }
      )
        .then(data => {
          data.records.forEach(item => {
            item.createTime = moment(item.createTime).format('YYYY-MM-DD');
            if (item.publishTime) {
              item.publishTime = moment(item.publishTime).format('YYYY-MM-DD');
            }
          });
          if (sIndex || sIndex === 0) {
            this.tabsData[fIndex].children[sIndex].records = data.records;
          } else {
            this.tabsData[fIndex].records = data.records;
          }
          //替换数据并且本地化保存
          switch (id) {
            case 1:
              this.tabsData0[1] = this.tabsData[0];
              this.tabsData0 = JSON.parse(JSON.stringify(this.tabsData0));
              sessionStorage.setItem('tabsData0', JSON.stringify(this.tabsData0));
              break;
            case 2:
              this.tabsData0[0] = this.tabsData[1];
              this.tabsData0 = JSON.parse(JSON.stringify(this.tabsData0));
              sessionStorage.setItem('tabsData0', JSON.stringify(this.tabsData0));
              break;
            case 3:
              this.tabsData1[0] = this.tabsData[2];
              this.tabsData1 = JSON.parse(JSON.stringify(this.tabsData1));
              sessionStorage.setItem('tabsData1', JSON.stringify(this.tabsData1));
              break;
            case 4:
              this.tabsData3[0] = this.tabsData[3];
              this.tabsData3 = JSON.parse(JSON.stringify(this.tabsData3));
              sessionStorage.setItem('tabsData3', JSON.stringify(this.tabsData3));
              break;
            case 5:
              this.tabsData2[0] = this.tabsData[4];
              this.tabsData2 = JSON.parse(JSON.stringify(this.tabsData2));
              sessionStorage.setItem('tabsData2', JSON.stringify(this.tabsData2));
              break;
            case 6:
              /* this.tabsData2[1] = this.tabsData[5];
              this.tabsData2 = JSON.parse(JSON.stringify(this.tabsData2));
              sessionStorage.setItem('tabsData2', JSON.stringify(this.tabsData2)); */
              /* this.tabsData1[2] = this.tabsData[5];
              this.tabsData1 = JSON.parse(JSON.stringify(this.tabsData1));
              sessionStorage.setItem('tabsData1', JSON.stringify(this.tabsData1)); */
              break;
            //关于协会模块不显示
            case 7:
              break;
            case 8:
              this.tabsData1[1] = this.tabsData[7];
              this.tabsData1 = JSON.parse(JSON.stringify(this.tabsData1));
              sessionStorage.setItem('tabsData1', JSON.stringify(this.tabsData1));
              break;
            case 9:
              this.tabsData4[0] = this.tabsData[8];
              this.tabsData4 = JSON.parse(JSON.stringify(this.tabsData4));
              sessionStorage.setItem('tabsData4', JSON.stringify(this.tabsData4));
              break;
            default:
              console.log('出错了');
          }
        })
        .catch(e => {
          console.log('失败');
        });
    },
    getSlideList() {
      this.$api(
        this.$config.apiUrl.frontList,
        {
          isShuffling: 1
        },
        { method: 'get' }
      )
        .then(data => {
          this.swiperSlides = data.records;
          sessionStorage.setItem('swiperSlides', JSON.stringify(this.swiperSlides));
        })
        .catch(e => {
          console.log('失败');
        });
    },
    getMember() {
      this.$api(this.$config.apiUrl.member, {}, { method: 'get' })
        .then(data => {
          this.member = data;
          sessionStorage.setItem('member', JSON.stringify(this.member));
        })
        .catch(e => {
          console.log('失败');
        });
    },
    tClick(val) {
      console.log(val);
    },
    openLink(id) {
      let routeData = this.$router.resolve({
        name: 'Detail',
        params: { id: id }
      });
      window.open(routeData.href, '_blank');
    },
    toEmail(val) {
      let routeData = this.$router.resolve({
        name: 'Msg',
        params: { tno: val }
      });
      window.open(routeData.href, '_blank');
    },
    //TODO
    toTrain() {
      window.open('http://www.gdgpa.org.cn/cgxh/#/main/train');
    }
  },
  components: {
    Header,
    Footer,
    FriendshipLinks,
    NewsTabs,
    swiper,
    swiperSlide,
    vueSeamlessScroll
  }
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1198px;
  .content {
    background: #fff;
    padding: 0 16px;
    box-sizing: content-box;
    .tPic {
      img {
        display: block;
        width: 100%;
      }
    }
    .tmt {
      margin-top: 18px;
    }
    .tTop {
      overflow: hidden;
      padding-top: 18px;
      .tTLeft {
        float: left;
        width: 505px;
        height: 310px;
        .slideItem {
          position: relative;
          height: 310px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
          .slideNewsTitle {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            padding-right: 140px;
            padding-left: 10px;
            height: 30px;
            line-height: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            background: rgba(0, 0, 0, 0.5);
            font-size: 14px;
            color: #fff;
            z-index: 2;
          }
        }
        /deep/.swiper-pagination {
          text-align: right;
          bottom: 6px;
          padding-right: 10px;
          left: auto;
          right: 0;
          width: auto;
        }
        /deep/.swiper-pagination-bullet {
          background: #fff;
          opacity: 0.8;
        }
        /deep/.swiper-pagination-bullet-active {
          background: #007aff;
          opacity: 0.8;
        }
        .swiper-pagination-bullet {
          width: 12px;
          height: 12px;
        }
      }
      .tTRight {
        overflow: hidden;
      }
    }
    .tMiddle {
      overflow: hidden;
      margin-top: 18px;
      padding-right: 12px;
      .tLeft {
        float: left;
        width: 846px;
      }
      /deep/.member {
        .name {
          position: absolute;
          left: 12px;
          top: 0;
          font-size: 18px;
          color: #000;
          font-weight: 600;
          line-height: 40px;
          width: 92px;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #013f99;
            z-index: 1;
          }
        }
        .el-tabs__header {
          padding-left: 92px;
          padding-top: 10px;
        }
        .el-tabs__item {
          font-size: 16px;
          color: #000;
          font-weight: normal;
          height: 30px;
          line-height: 30px;
          padding-right: 0;
        }
      }
      .tRight {
        overflow: hidden;
        padding-top: 38px;
        .qrCode {
          border: 1px solid #146adb;
          .qrTitle {
            background: #146adb;
            text-align: center;
            font-size: 18px;
            color: #fff;
            line-height: 30px;
            padding: 4px 0;
          }
          .qrPic {
            position: relative;
            height: 182px;
            img {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              margin: auto;
              width: auto;
              height: auto;
            }
          }
        }
        .consult {
          margin-top: 17px;
          padding-bottom: 11px;
          margin-bottom: 11px;
          border-bottom: 1px solid #146adb;
          .btn {
            background: #146adb;
            height: 40px;
            font-size: 0;
            padding-left: 47px;
            cursor: pointer;
            & + .btn {
              margin-top: 5px;
            }
            i,
            span {
              display: inline-block;
              vertical-align: middle;
            }
            i {
              background: url('~@img/icon-email.png') center center no-repeat;
              background-size: 36px auto;
              width: 41px;
              height: 36px;
            }
            span {
              font-size: 18px;
              color: #fff;
              line-height: 40px;
              margin-left: 5px;
            }
            &.trainBtn i {
              background: url('~@img/icon-train.png') center center no-repeat;
              background-size: 32px auto;
              width: 41px;
              height: 36px;
            }
          }
        }
      }
      .directory {
        .d-title {
          background: #146adb;
          text-align: center;
          font-size: 18px;
          color: #fff;
          line-height: 40px;
        }
        .d-list {
          border: 1px solid #146adb;
          height: 410px;
          overflow: hidden;
        }
      }
    }

    .activity {
      padding: 0 12px 24px;
      .d-title {
        border-bottom: 2px solid #013f99;
        margin-bottom: 24px;
        font-size: 0;
        span {
          position: relative;
          font-size: 18px;
          color: #000;
          line-height: 40px;
          font-weight: 600;
          display: inline-block;
          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #013f99;
            z-index: 1;
          }
        }
      }
      .swiper-container {
        padding: 0 40px;
        position: relative;
        .swiper-slide {
          background-position: center;
          background-size: cover;
          width: 300px;
          height: 160px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .swiper-button-prev,
        .swiper-button-next {
          top: 0;
          bottom: 0;
          width: 40px;
          height: auto;
          background: #fff;
          margin: 0;
        }
        .swiper-button-prev {
          left: 0;
          background: #fff url('~@img/arrow-l.png') no-repeat;
          background-position: right 15px center;
        }
        .swiper-button-next {
          right: 0;
          background: #fff url('~@img/arrow-r.png') no-repeat;
          background-position: 15px center;
        }
      }
      /* img {
        width: 100%;
        height: 160px;
      } */
    }
  }
}

.sWarp {
  width: 100%;
  height: 160px;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        width: 255px;
        height: 160px;
        margin-right: 10px;
        line-height: 120px;
        color: #fff;
        text-align: center;
        font-size: 30px;
        cursor: pointer;
      }
    }
  }
}

.cWarp {
  height: 409px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    li {
      list-style: none;
      line-height: 48px;
      font-size: 13px;
      color: #5e5a5a;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      padding: 0 10px;
    }
  }
}
</style>
